<template>
  <history-stack
    :default-view-component="() => import('./ConnectionCard.vue')"
    v-bind="$attrs"
    @stack:close="handleClose"
  />
</template>

<script>
export default {
  name: 'ConnectionHistoryStack',
  setup(props, { root }) {
    const handleClose = () => {
      root.$router.push({
        name: 'connections'
      });
    };
    return {
      handleClose
    };
  }
};
</script>
